import { render, staticRenderFns } from "./InsurerGuarantees.vue?vue&type=template&id=310472ba&scoped=true"
import script from "./InsurerGuarantees.vue?vue&type=script&lang=js"
export * from "./InsurerGuarantees.vue?vue&type=script&lang=js"
import style0 from "./InsurerGuarantees.vue?vue&type=style&index=0&id=310472ba&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310472ba",
  null
  
)

export default component.exports